import styled from '@emotion/styled';
import {
  Body,
  Box,
  Container,
  Divider,
  Heading,
  HStack,
  Icon,
} from '@hover/blueprint';
import { iChevronLeft, iChevronRight } from '@hover/icons';
import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { PRICING_TO_MATCH_PROPERTY } from '../../../constants';
import { IPricingToMatch } from '../../../interfaces/IPricingToMatch';

const settings = {
  dots: false,
  infinite: true,
  speed: 1500,
  autoplaySpeed: 10000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
};

const MobileSlider = styled(Slider)`
  @media screen and (max-width: 768px) {
    .slick-list {
      max-height: 100% !important;
    }
  }
`;

const Mobile: React.FC = () => {
  const sliderRef = useRef<Slider>(null);

  const onNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const onPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };

  return (
    <Container
      maxW="100%"
      px={0}
      d={{ base: 'block', tablet: 'none' }}
      mb={700}
    >
      <Heading textAlign="center" size={500} isLight marginBottom={700} as="h2">
        Pricing to match each property
      </Heading>
      <HStack w="100%" justifyContent="center" spacing="107px" mb="54px">
        <Icon
          onClick={onPrev}
          strokeWidth="2px"
          size="default"
          color="primary.600"
          icon={iChevronLeft}
        />
        <Icon
          onClick={onNext}
          strokeWidth="2px"
          size="default"
          color="primary.600"
          icon={iChevronRight}
        />
      </HStack>
      <Box d="block" maxW="100%" overflow="hidden">
        <MobileSlider ref={sliderRef} {...settings}>
          {PRICING_TO_MATCH_PROPERTY.map((match: IPricingToMatch) => (
            <Box px={200} key={match.id} flexDir="column" alignItems="center">
              <Box w="100%" pb="20px" bg="brandTan.100">
                <Box
                  w="100%"
                  pt={400}
                  flexDir="column"
                  bg="brandBrown.100"
                  borderRadius="8px"
                  px={500}
                  pb={400}
                  shadow="distance300"
                  minHeight="320px"
                >
                  <Body
                    mx="auto"
                    isBold
                    size={600}
                    marginBottom={100}
                    color="neutral.600"
                  >
                    {match.title}
                  </Body>
                  <Body mx="auto" isBold size={400} marginBottom={100}>
                    {match.facets}
                  </Body>
                  <Box mx="auto" maxH="183px" mt={800}>
                    {match.image}
                  </Box>
                </Box>
              </Box>
              <Box flexDir="column" bg="brandTan.100">
                <HStack px={600} spacing="auto" h="76px" alignItems="center">
                  <Box flexDir="column">
                    <Heading
                      as="h3"
                      size={200}
                      fontWeight={700}
                      marginBottom={0}
                    >
                      ROOF-ONLY
                    </Heading>

                    <Body
                      size={200}
                      letterSpacing="1px"
                      color="neutral.600"
                      mb={0}
                    >
                      FROM PHOTOS
                    </Body>
                  </Box>
                  <Heading as="p" size={500} fontWeight={700} marginBottom={0}>
                    ${match.roofOnly}
                  </Heading>
                </HStack>
                <Divider
                  borderColor="neutral.400"
                  borderWidth={0}
                  borderTopWidth="1px"
                  my={0}
                />

                <HStack px={600} spacing="auto" h="76px" alignItems="center">
                  <Box flexDir="column">
                    <Heading
                      as="h3"
                      size={200}
                      fontWeight={700}
                      marginBottom={0}
                    >
                      COMPLETE
                    </Heading>
                    <Body
                      size={200}
                      letterSpacing="1px"
                      color="neutral.600"
                      mb={0}
                    >
                      FROM PHOTOS
                    </Body>
                  </Box>
                  <Heading as="p" size={500} fontWeight={700} marginBottom={0}>
                    ${match.complete}
                  </Heading>
                </HStack>
                <Divider
                  borderColor="neutral.400"
                  borderWidth={0}
                  borderTopWidth="1px"
                  my={0}
                />

                <HStack px={600} spacing="auto" h="76px" alignItems="center">
                  <Box flexDir="column">
                    <Heading
                      as="h3"
                      size={200}
                      fontWeight={700}
                      marginBottom={0}
                    >
                      COMPLETE
                    </Heading>
                    <Body
                      size={200}
                      letterSpacing="1px"
                      color="neutral.600"
                      mb={0}
                    >
                      FROM A BLUEPRINT
                    </Body>
                  </Box>
                  <Heading as="p" size={500} fontWeight={700} marginBottom={0}>
                    ${match.completeBlueprint}
                  </Heading>
                </HStack>
                <Divider
                  borderColor="neutral.400"
                  borderWidth={0}
                  borderTopWidth="1px"
                  my={0}
                />
              </Box>
            </Box>
          ))}
        </MobileSlider>
      </Box>
    </Container>
  );
};

export default Mobile;
